const MOBILE_PLATFORM_ROUTE_NAMES = {
  HOME: 'mobilePlatformHome',
};

export default MOBILE_PLATFORM_ROUTE_NAMES;
